"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../static/icons/icons");

var _colorIcons = require("../../../static/icons/colorIcons");

var _squares = require("../../../static/icons/squares");

var _Icon = _interopRequireDefault(require("../Icon"));

var _style = require("./style");

var _DiscontinuousLine = _interopRequireDefault(require("../DiscontinuousLine"));

var _ColorIcon = _interopRequireDefault(require("../ColorIcon"));

var FlightSummary = function FlightSummary(_ref) {
  var arrivalAirportName = _ref.arrivalAirportName,
      arrivalCity = _ref.arrivalCity,
      arrivalCityCode = _ref.arrivalCityCode,
      arrivalTimeDate = _ref.arrivalTimeDate,
      arriveNextDay = _ref.arriveNextDay,
      companyCode = _ref.companyCode,
      companyName = _ref.companyName,
      departureAirportName = _ref.departureAirportName,
      departureCity = _ref.departureCity,
      departureCityCode = _ref.departureCityCode,
      departureDayDate = _ref.departureDayDate,
      departureFlightNumber = _ref.departureFlightNumber,
      departureTimeDate = _ref.departureTimeDate,
      operatedBy = _ref.operatedBy,
      stops = _ref.stops,
      whiteBackground = _ref.whiteBackground;
  return _react["default"].createElement(_style.Container, {
    whiteBackground: whiteBackground
  }, _react["default"].createElement(_style.Title, null, _react["default"].createElement(_style.Company, null, !!_squares.SQUARES[companyCode] && _react["default"].createElement(_ColorIcon["default"], {
    icon: _squares.SQUARES[companyCode],
    size: 24
  }), _react["default"].createElement(_style.CompanyName, {
    icon: !_squares.SQUARES[companyCode]
  }, companyName)), _react["default"].createElement(_style.Date, null, departureDayDate)), operatedBy && _react["default"].createElement(_style.OperatedBy, null, operatedBy), _react["default"].createElement(_style.DiscontinuousLineContainer, null, _react["default"].createElement(_DiscontinuousLine["default"], {
    color: "#979797",
    margin: 10,
    direction: "vertical",
    length: -30
  }, _react["default"].createElement(_style.Content, null, _react["default"].createElement(_style.IconLineFirst, null, _react["default"].createElement(_Icon["default"], {
    icon: _icons.ICONS.PLANEDOWN,
    size: 20
  })), _react["default"].createElement(_style.FlightTitle, {
    stops: true
  }, _react["default"].createElement(_style.FlightInfo, null, "".concat(departureTimeDate, " ").concat(departureCity, " ").concat(departureCityCode)), _react["default"].createElement(_style.FlightAirport, null, "".concat(departureAirportName, " (").concat(departureFlightNumber, ")"))), stops && stops.map(function (stop) {
    return _react["default"].createElement(_style.Stop, {
      key: stop.airportName
    }, _react["default"].createElement(_style.IconLine, null, _react["default"].createElement(_ColorIcon["default"], {
      icon: _colorIcons.COLOR_ICONS.CIRCLESTOP,
      size: 8
    })), _react["default"].createElement(_style.RouteAirport, null, "".concat(stop.airportName, " (").concat(stop.flightNumber, ")")));
  }), _react["default"].createElement(_style.FlightTitle, {
    stops: !!stops
  }, _react["default"].createElement(_style.FlightInfo, null, "".concat(arrivalTimeDate, " "), arriveNextDay && _react["default"].createElement(_style.Next, null, "+1"), _react["default"].createElement(_style.CityAndCode, {
    arriveNextDay: arriveNextDay
  }, "".concat(arrivalCity, " ").concat(arrivalCityCode))), _react["default"].createElement(_style.FlightAirport, null, arrivalAirportName)), _react["default"].createElement(_style.IconLineFinal, null, _react["default"].createElement(_ColorIcon["default"], {
    icon: _colorIcons.COLOR_ICONS.CIRCLEDESTINATION,
    size: 15
  }))))));
};

FlightSummary.propTypes = {
  arrivalAirportName: _propTypes["default"].string.isRequired,
  arrivalCity: _propTypes["default"].string.isRequired,
  arrivalCityCode: _propTypes["default"].string.isRequired,
  arrivalTimeDate: _propTypes["default"].string.isRequired,
  arriveNextDay: _propTypes["default"].bool,
  companyCode: _propTypes["default"].string.isRequired,
  companyName: _propTypes["default"].string.isRequired,
  departureAirportName: _propTypes["default"].string.isRequired,
  departureCity: _propTypes["default"].string.isRequired,
  departureCityCode: _propTypes["default"].string.isRequired,
  departureDayDate: _propTypes["default"].string.isRequired,
  departureFlightNumber: _propTypes["default"].string.isRequired,
  departureTimeDate: _propTypes["default"].string.isRequired,
  stops: _propTypes["default"].arrayOf(_propTypes["default"].object),
  whiteBackground: _propTypes["default"].bool,
  operatedBy: _propTypes["default"].string
};
FlightSummary.defaultProps = {
  arriveNextDay: false,
  stops: undefined,
  whiteBackground: false,
  operatedBy: undefined
};
var _default = FlightSummary;
exports["default"] = _default;